import type { Editor } from '@tiptap/core';

/** Caller dimensions `useEditorContentSync` hands the host's apply unchanged. */
export interface EditorContentSyncContext {
  editorVariant: 'block_v1' | 'block_markdown' | 'json';
  surface?: 'note' | 'note_offscreen';
}

/** Members the host injects; the package never imports app telemetry. */
export interface EditorHostConfig {
  /** Receives the call-site literal of a post-destroy access. The host owns dedup, caps and transport. */
  reportDestroyedEditorAccess?: (callSite: string) => void;
  /** The host's HTML apply for content sync; it owns failure logging and render telemetry. */
  applyHtmlContentPreservingSelection?: (
    editor: Editor,
    content: string,
    context: EditorContentSyncContext
  ) => void;
}

let hostConfig: EditorHostConfig = {};

/** Replaces the whole config; called once by the app bootstrap. Unset means silent. */
export function configureEditor(config: EditorHostConfig): void {
  hostConfig = { ...config };
}

export function getEditorHostConfig(): EditorHostConfig {
  return hostConfig;
}
